import { Box } from "@mui/material";
import useAPI from "../../../../../api/hooks/useAPI";
import { ComplexEntityTypes } from "../../../../../utils/constants";
import { getDatastoreSmartFiltersInfo } from "./datastoreSmartFiltersInfo";
import { getHostSmartFiltersInfo } from "./hostSmartFiltersInfo";
import { getNHISmartFiltersInfo } from "./nhiSmartFiltersInfo";
import { getServerSmartFiltersInfo } from "./serverSmartFiltersInfo";
import { getSharedSmartFilters } from "./sharedSmartFilters";
import SmartFilterButton from "./SmartFilterButton";
import { getUserSmartFiltersInfo } from "./userSmartFiltersInfo";
import { createEmptyFilters } from "./utils";

export default function EntityTypeSmartFilters({
  entityType,
  appliedFilters,
  setAppliedFilters,
  filterAndOrLogics,
  setFilterAndOrLogics,
  fetchedEntities,
}) {
  const { trackEvent } = useAPI();

  const filtersInfoByType = {
    [ComplexEntityTypes.HOST]: getHostSmartFiltersInfo(
      fetchedEntities,
      appliedFilters,
      setAppliedFilters,
      filterAndOrLogics,
      setFilterAndOrLogics
    ),
    [ComplexEntityTypes.USER]: getUserSmartFiltersInfo(
      fetchedEntities,
      appliedFilters,
      setAppliedFilters,
      filterAndOrLogics,
      setFilterAndOrLogics
    ),
    [ComplexEntityTypes.SERVER]: getServerSmartFiltersInfo(
      fetchedEntities,
      appliedFilters,
      setAppliedFilters
    ),
    [ComplexEntityTypes.DATA_STORE]: getDatastoreSmartFiltersInfo(
      appliedFilters,
      setAppliedFilters
    ),
    [ComplexEntityTypes.NONHUMAN_IDENTITY]: getNHISmartFiltersInfo(
      appliedFilters,
      setAppliedFilters,
      filterAndOrLogics,
      setFilterAndOrLogics
    ),
    [ComplexEntityTypes.APP]: [],
  };

  const sharedSmartFilters = getSharedSmartFilters(
    appliedFilters,
    setAppliedFilters
  );

  const filters = [...sharedSmartFilters, ...filtersInfoByType[entityType]];
  return (
    <Box display="flex" gap={1}>
      {filters.map((filter, index) => (
        <SmartFilterButton
          key={index}
          text={filter.text}
          selected={filter.applied}
          disabled={filter.disabled ?? false}
          onClick={() => {
            trackEvent(
              `User clicked on smart filter ${filter.text} in ${entityType} entities page`
            );
            filter.onClick();
          }}
          onRemove={() => {
            trackEvent(
              `User disabled smart filter ${filter.text} in ${entityType} entities page`
            );
            setAppliedFilters((prev) => createEmptyFilters(prev));
          }}
        />
      ))}
    </Box>
  );
}
